<style lang="scss" src='./GrassType.scss' scoped></style>
<template src="./GrassType.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import Placeholder from '@/components/placeholders/Placeholders.vue';
import {
  getGrassTypes,
  postGrassTypes,
  editGrassTypes
} from '@/api/index';
import i18n from './../../../../i18n';

import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';

import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';

export default {
  name: 'GrassType',
  extends: SecurityComponent,
  components: {
    VueSlider,
    Placeholder,
  },
  data() {
    return {
      create: true,
      selectedZone: null,
      grassTypesAvailable: [],
      newActive: false,
      editGrass: null,
      grassName: null,
      thresholds: this.G_getThresholds(),
    };
  },
  computed: {
  },

  methods: {
    unselectAll() {
      this.grassTypesAvailable.forEach((s) => {
        s.selected = false;
      });
    },

    showNewGrassModal() {
      this.unselectAll();
      this.newActive = true;
      this.grassName = null
      this.thresholds = this.G_getThresholds();
    },

    showEditGrassModal(item) {
      this.unselectAll();
      item.selected = true;
      this.editGrass = item;
      this.grassName = i18n.t(item.i18n);
      this.newActive = false;
      if(item.threshold){
        this.setThresholdValues(item.threshold);
      }else{
        this.thresholds = this.G_getThresholds();
      }
    },

    hideEditGrassModal(item) {
      this.editGrass = null;
      this.grassName = null;
      this.newActive = false;
      this.thresholds = this.G_getThresholds();
    },

    setThresholdValues(threshold) {
      this.thresholds.forEach((t) => {
        const minVal = this.G_getMeasurement({
          val: threshold[`min_${t.key}`],
          uom: t.uom
        });
        const maxVal = this.G_getMeasurement({
          val: threshold[`max_${t.key}`],
          uom: t.uom
        });
        t.value = [minVal, maxVal];
      });
    },

    saveGrassType(){
      if(this.grassName){

        let grassTypeThresholds = {};
        this.thresholds.forEach((t) => {
          grassTypeThresholds[`min_${t.key}`] = this.G_getDefaultMeasurement({
            val: t.value[0],
            uom: t.uom
          });
          grassTypeThresholds[`max_${t.key}`] = this.G_getDefaultMeasurement({
            val: t.value[1],
            uom: t.uom
          });
        });

        delete grassTypeThresholds.min_salinity_ms;
        delete grassTypeThresholds.max_salinity_ms;
        delete grassTypeThresholds.min_et_rate;
        delete grassTypeThresholds.max_et_rate;

        let data = {name: this.grassName, thresholds: grassTypeThresholds};

        if(this.newActive) {
          postGrassTypes(data).then((resp)=>{
            this.loadData();
            this.hideEditGrassModal();
            //this.$bvModal.hide('modal-add-grass');
          })
        } else {
          editGrassTypes(data, this.editGrass.grass_type_id).then((resp)=>{
            this.loadData();
            //this.$bvModal.hide('modal-add-grass');
          })
        }
      }
    },

    async loadData() {
      this.loadAvailableGrassTypes();
    },

     loadAvailableGrassTypes() {
      getGrassTypes().then((resp) => {
        if (resp.grass_types && resp.grass_types.length) {
          this.grassTypesAvailable = resp.grass_types.map(grass => ({...grass, selected: false}));
        } else {
          this.grassTypesAvailable = [];
        }
      })
    },
  },
  async mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Settings Grass Type");
      this.$analytics.logEvent("web_settings_grass_type");
    }

    this.loadData();
  },
};

</script>
